import { useEffect, useState } from 'react';
import { useEffectEvent } from 'academy-common-lib/hooks/useEffectEvent';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import HomePageSection from '../../components/Layouts/HomePageSection';
import { CardsSection } from 'academy-common-lib/features/cardsSection/components/CardsSection';
import { PageSectionHeading } from '../../components/SectionHeading';
import UsageTracker from '../../utils/UsageTracker';
import { usePersonaRecommendations } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const getPersonaTitle = persona => {
  switch (persona) {
    case 'MARKETING':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.personaRecommendations.marketingTitle"
      });
    case 'SALES':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.personaRecommendations.salesTitle"
      });
    case 'SERVICE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.personaRecommendations.serviceTitle"
      });
    case 'DEFAULT':
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.personaRecommendations.defaultTitle"
      });
  }
};
const getPersonaSubtitle = persona => {
  switch (persona) {
    case 'MARKETING':
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.tracks.personaRecommendations.marketingSubtitle"
      });
    case 'SALES':
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.tracks.personaRecommendations.salesSubtitle"
      });
    case 'SERVICE':
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.tracks.personaRecommendations.serviceSubtitle"
      });
    case 'DEFAULT':
    default:
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.tracks.personaRecommendations.defaultSubtitle"
      });
  }
};
const PersonaRecommendationsHeader = ({
  personas
}) => {
  const persona = personas.length === 1 ? personas[0] : 'DEFAULT';
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "start",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBlockEnd: "0",
    children: /*#__PURE__*/_jsx(PageSectionHeading, {
      marginBlockEnd: "0",
      subtitle: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        gap: "200",
        children: getPersonaSubtitle(persona)
      }),
      title: getPersonaTitle(persona)
    })
  });
};
export const PersonaRecommendations = ({
  onRenderEmpty = () => {}
}) => {
  const {
    isTablet
  } = useMediaQuery();
  const [maxCards, setMaxCards] = useState(isTablet ? 3 : undefined);
  const {
    personas,
    recommendations,
    isLoading,
    error
  } = usePersonaRecommendations(maxCards);
  const handleOnItemClick = (item, index) => {
    var _item$progress;
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'content-card-click',
      contentType: item.type,
      trackId: item.id,
      appearsIn: 'recommendations',
      position: index + 1,
      name: item.name,
      style: 'list',
      isInProgress: ((_item$progress = item.progress) === null || _item$progress === void 0 ? void 0 : _item$progress.status) === 'IN_PROGRESS'
    });
  };
  const isEmpty = !(recommendations !== null && recommendations !== void 0 && recommendations.length) && !isLoading;
  const onRenderEmptyEvent = useEffectEvent(onRenderEmpty);
  useEffect(() => {
    if (isEmpty) {
      onRenderEmptyEvent();
    }
  }, [isEmpty]);
  if (isEmpty) {
    return null;
  }
  return /*#__PURE__*/_jsx(HomePageSection, {
    paddingBlock: "0",
    children: /*#__PURE__*/_jsx(CardsSection, {
      appearsIn: "recommendations",
      cardsContainerProps: {
        paddingBlockEnd: '0'
      },
      content: recommendations,
      direction: isTablet ? 'column' : 'row',
      error: error,
      errorMarker: "HOMEPAGE_PERSONA_RECOMMENDATIONS_ERROR",
      flush: true,
      header: /*#__PURE__*/_jsx(PersonaRecommendationsHeader, {
        personas: personas
      }),
      isLoading: isLoading,
      maxSkeletonListLength: maxCards,
      navMarker: "HOMEPAGE_PERSONA_RECOMMENDATIONS_LOADED",
      onItemClick: handleOnItemClick,
      setMaxCards: setMaxCards,
      size: isTablet ? 'small' : 'large'
    })
  });
};